<template>
  <div class="treatment-item" :class="{ done: is_done && is_paid }" :style="treatment_style">
    <div v-if="is_selectable" class="treatment-selected-icon">
      <div class="form-check form-check-inline">
        <input v-if="is_selectable" @change="toggleSelected" class="form-check-input" type="checkbox" :id="checkbox_id"
          :checked="selected" />
        <label class="form-check-label" :for="checkbox_id"></label>
      </div>
    </div>
    <div v-if="!total && clinic_type == 'dental'" @click="toggleEdit" class="treatment-kind-icon">
      <treatment-icon :icon="product_icon" :color="getIconColor(treatment)"></treatment-icon>
    </div>
    <div @click="toggleEdit" class="treatment-body">
      <span class="treatment-date"><strong>{{ treatment_date }}</strong> - {{ clinic_name }} -</span>
      <span class="treatment-name">

        <span>{{ treatment.full_name }}</span>

        <span v-if="treatment.max_sessions">
          ( {{ treatment.sessions_done }} de {{ treatment.max_sessions }} Sesiones )
        </span>

        <span v-if="!is_done && treatment.product.enable_stock">
          <strong v-if="treatment.product.stock <= 0"> - Agotado</strong>
          <span v-else> - Quedan {{ treatment.product.stock }} uds.</span>
        </span>

        <small class="treatment-variants">
          <span class="treatment-variant" v-for="variant, index in treatment_variants" :key="index">
            {{ variant.attr }}:{{ variant.value }}
          </span>
        </small>
      </span>

      <div class="treatment-notes">{{ treatment_notes }}</div>
    </div>
    <div v-if="total" class="treatment-total mx-3">
      {{ pretty_total }}
    </div>

    <div class="treatment-pinned-icon" @click="pinTreatment" data-toggle="tooltip" data-placement="top"
      title="Fijar Tratamiento" :class="{ pinned: is_pinned }">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <g clip-path="url(#clip0_272_1148)">
          <path
            d="M12.9941 6.35625C12.7995 6.61985 12.513 6.80068 12.1913 6.86284C11.8696 6.92501 11.5363 6.86397 11.2576 6.69185C11.1044 6.5905 11.1044 6.59275 10.9355 6.76391C10.1089 7.60175 9.88143 7.82698 9.19223 8.50942L8.88367 8.81798C8.83474 8.86293 8.82636 8.86133 8.8634 8.91259C9.74179 10.2347 9.18322 11.7167 8.36565 12.6626C7.95017 13.1092 7.51857 13.1165 7.08185 12.7144C6.3225 11.9527 5.76242 11.4097 4.93769 10.5613C4.85902 10.4927 4.89284 10.48 4.78679 10.5613C4.13814 11.0928 3.48798 11.6213 2.83632 12.1468C2.44443 12.4644 2.05103 12.7827 1.65613 13.1018C1.53477 13.2186 1.37603 13.2888 1.20793 13.3C1.14231 13.2987 1.07761 13.2843 1.01766 13.2576C0.957696 13.2309 0.903692 13.1925 0.85883 13.1446C0.543512 12.836 0.777748 12.514 0.8791 12.3766C1.68932 11.2664 2.47939 10.1604 3.30705 9.05223C3.36698 8.96857 3.35723 8.98939 3.28453 8.91259C2.53706 8.17159 2.01868 7.6519 1.34757 6.97789C0.872186 6.5066 0.899499 6.03038 1.40613 5.59049C2.35659 4.76166 3.98498 4.32922 5.12463 5.16031C5.13364 5.16707 5.1404 5.17157 5.14715 5.17607C6.12879 4.18425 6.54831 3.76528 7.40618 2.9148C7.20004 2.63179 7.10794 2.28158 7.14819 1.93379C7.18844 1.58599 7.35809 1.26607 7.62342 1.03763C7.88874 0.809184 8.23032 0.688946 8.58023 0.700815C8.93015 0.712683 9.26279 0.855789 9.51203 1.10168C10.922 2.49811 11.5256 3.10397 12.9197 4.5094C13.1586 4.75338 13.2985 5.07733 13.3122 5.41852C13.326 5.75971 13.2126 6.09386 12.9941 6.35625Z">
          </path>
        </g>
        <defs>
          <clipPath id="clip0_272_1148">
            <rect width="14" height="14" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
    </div>

    <div v-if="show_done" @click="markDone" data-toggle="tooltip" data-placement="top" title="Completar Tratamiento"
      class="treatment-done-icon" :class="{ done: is_done, doneprior: is_done_prior }">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill-rule="evenodd"
          d="M22.707 3.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L12 12.586l9.293-9.293a1 1 0 0 1 1.414 0z"
          clip-rule="evenodd" />
        <path fill-rule="evenodd"
          d="M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7a1 1 0 1 1 2 0v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h11a1 1 0 1 1 0 2H5z"
          clip-rule="evenodd" />
      </svg>
    </div>
    <div @click="markPaid" class="treatment-paid-icon" data-toggle="tooltip" data-placement="top"
      title="Pagar Tratamiento" :class="{ paid: is_paid, notpaid: is_not_paid }">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20">
        <path
          d="M15.9 16.4c-.3-.5-.9-.6-1.4-.4-3.4 2-8 .7-9.8-3.1H9c.6 0 1-.4 1-1s-.4-1-1-1H4.1C4 10.3 4 9.7 4.1 9H9c.6 0 1-.4 1-1s-.4-1-1-1H4.7c1.8-3.8 6.4-5.1 9.8-3.1.5.3 1.1.1 1.4-.4.3-.5.1-1.1-.4-1.4C10.7-.6 4.4 1.6 2.5 7H1c-.6 0-1 .4-1 1s.4 1 1 1h1.1c-.1.7-.1 1.3 0 2H1c-.6 0-1 .4-1 1s.4 1 1 1h1.5c1.9 5.4 8.2 7.6 13 4.8.5-.3.6-.9.4-1.4z" />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    clinic_type: { required: true },
    treatment: { required: true },
    clinics: { required: true },
    selected: { default: false },
    total: { default: 0 },
    show_done: { default: true },
    selectable: { default: false }
  },
  computed: {
    treatment_variants() {
      let ret = [];

      for (let id in this.treatment.variants) {
        for (let attr in this.treatment.variants[id]) {
          ret.push({
            attr: attr,
            value: this.treatment.variants[id][attr]
          });
        }
      }

      return ret;
    },
    treatment_notes() {
      let lines = [];
      if (this.treatment.quotation_id) {
        if (this.is_core) {
          lines.push("Planificado");
        } else {
          lines.push("Presupuestado");
        }
        if (this.treatment.is_approved) {
          lines.push("Aprobado");
        }
      } else {
        lines.push('Pendiente');
      }

      if (this.treatment.notes && this.treatment.notes != '') {
        lines.push(this.treatment.notes);
      }

      if (this.treatment.done_at && this.treatment.status == 'done') {
        let d = moment(this.treatment.done_at);
        lines.push('Realizado: ' + d.format('DD/MM/YY'));
      };

      if (this.treatment.paid_at && this.treatment.is_paid) {
        let d = moment(this.treatment.paid_at);
        lines.push('Pagado: ' + d.format('DD/MM/YY'));
      };

      return lines.join(" - ");
    },
    product_icon() {
      if (this.treatment.product) {
        return this.treatment.product.icon;
      }

      return null;
    },
    clinic_name() {
      let name = this.clinics[this.treatment.clinic_id] || null;
      return name ? name : "";
    },
    pretty_total() {
      return WabiDent.fmtMoney(this.total);
    },
    treatments_show_done_date() {
      return false;
    },
    treatment_date() {
      let dates = [
        moment(this.treatment.created_at).toDate().toLocaleDateString()
      ];
      let done_at = this.treatment.done_at;
      let paid_at = this.treatment.paid_at;

      if (this.treatments_show_done_date && this.treatment.status == 'done' && done_at) {
        dates.push('Realz: ' + moment(done_at).toDate().toLocaleDateString());
      }

      return dates.join(' - ');
    },
    treatment_teeth() {
      return this.treatment.teeth.reduce((accum, value) => {
        return accum + ` ${value}`;
      }, "");
    },
    checkbox_id() {
      return `treatment_check_${this.treatment.id}`;
    },
    is_done() {
      return this.treatment.status == "done";
    },
    is_done_prior() {
      return this.treatment.status == "done_prior";
    },
    is_quoted() {
      return Boolean(this.treatment.quotation_id);
    },
    is_pinned() {
      return this.treatment.is_pinned;
    },
    is_paid() {
      return this.is_quoted && this.treatment.is_paid;
    },
    is_not_paid() {
      return this.is_quoted && !this.treatment.is_paid;
    },
    is_selectable() {
      return this.selectable || !(this.is_quoted || this.is_done_prior);
    },
    treatment_style() {
      let ret = {};

      if (this.treatment && this.treatment.color) {
        ret["background-color"] = window.WabiDent.hexToRGBA(
          this.treatment.color,
          0.125
        );
      } else if (this.treatment.is_approved) {
        ret["background-color"] = 'rgba(129, 199, 132, 0.125)';
      } else if (this.treatment.quotation_id != null) {
        ret["background-color"] = 'rgba(255, 241, 118, 0.125)';
      }

      return ret;
    },
    ...mapGetters(['clinic', 'is_core'])
  },
  methods: {
    getIconColor(treatment) {
      return WabiDent.getIconColor(treatment);
    },
    toggleSelected(ev) {
      this.$emit("select", this.treatment, ev.target.checked);
    },
    toggleEdit() {
      this.$emit("edit", this.treatment);
    },
    pinTreatment() {
      this.$emit("pin", this.treatment);
    },
    markDone() {
      this.$emit("done", this.treatment);
    },
    markPaid() {
      this.$emit("paid", this.treatment);
    },
  },
};
</script>

<style lang="scss">
.treatment-item {
  cursor: pointer;
  padding: 9px;
  background-color: var(--theme-grey-bg);
  border-bottom: 1px var(--theme-grey) solid;
  margin-bottom: 7px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;

  &.done {
    background-color: rgba(84, 211, 173, 0.1);
  }

  .treatment-kind-icon,
  .treatment-selected-icon,
  .treatment-pinned-icon,
  .treatment-done-icon,
  .treatment-paid-icon {
    flex: 0 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--theme-grey);

    svg,
    svg * {
      fill: currentColor;
    }

    .form-check {
      margin: 1px 0 0 0;
    }

    .wabident-treatment-icon {
      width: 20px;
      height: 20px;
      padding: 5px 0;
      font-size: 18px;
    }
  }

  .treatment-pinned-icon.pinned {
    color: var(--theme-color-attended);
  }

  .treatment-done-icon.done {
    color: var(--theme-color-attended);
  }

  .treatment-done-icon.doneprior {
    color: var(--theme-color-absent);
  }

  .treatment-paid-icon.paid {
    color: var(--theme-color-attended);
  }

  .treatment-paid-icon.notpaid {
    color: var(--theme-color-absent);
  }

  .treatment-body {
    flex: 1 1 auto;

    .treatment-date {
      color: var(--theme-line-color);
      font-size: 14px;
      font-weight: 500;
      vertical-align: middle;

      strong {
        font-weight: 700;
        color: var(--theme-text-color);
      }
    }

    .treatment-name {
      color: var(--theme-text-color);
      vertical-align: middle;
      font-size: 16px;
      font-weight: normal;
    }

    .treatment-notes {
      font-size: 12px;
      color: var(--theme-grey);
      font-weight: 500;
    }
  }

  .treatment-total {
    font-size: 18px;
    color: var(--theme-color-attended);
    letter-spacing: 0.36px;
    flex: 0 0 120px;
    text-align: right;
  }

  .treatment-variant {
    font-weight: 500;
    font-size: 0.9em;
  }

  .treatment-variant::before {
    content: '|';
    margin: 5px;
    display: inline-block;
  }
}
</style>
